<template>
  <div style="width: 100%">
    <draggable
      v-model="parentData"
      v-bind="{
        animation: 250,
        ghostClass: 'ghostClass',
      }"
      @sort="sortEnd"
    >
      <div
        flex
        v-for="(item, index) in parentData"
        :key="index"
        class="option-item"
      >
        <div style="margin-right: 10px" class="questionSeq">
          {{ sortString[index] }}
        </div>
        <bc-view-common
          flex-box="1"
          @click.native="editOption"
          :content="item.content"
          placeholder="点击编辑选项"
          :fileInfo="item.fileInfo"
        ></bc-view-common>
      </div>
    </draggable>

    <!--    <el-button @click="createOption" class="create-option" icon="el-icon-circle-plus">-->
    <!--      添加选项-->
    <!--    </el-button>-->

    <!--    <bc-edit-common :title="dialogTitle" ref="editCommon" @changeContent="changeContent">-->
    <!--      <el-button style="margin-left: 10px" @click="removeOption">删除此选项</el-button>-->
    <!--    </bc-edit-common>-->

    <el-dialog
      top="60px"
      width="710px"
      custom-class="dialog-edit"
      destroy-on-close
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      :visible.sync="isShowDialog"
      @close="close"
    >
      <div>
        <div
          v-for="(item, index) in optionsList"
          :key="index"
          flex="cross:center"
          class="edit-item"
        >
          <div
            style="
              width: 602px;
              padding-bottom: 16px;
              border-bottom: 2px solid #f2f2f2;
            "
          >
            <div class="dot-title--dialog" flex="main:justify">
              <div>选项{{ sortString[index] }}</div>

              <div flex="cross:center" v-if="!isCloze">
                <bc-upload
                  relationType="stem-files"
                  @startUpload="startUpload"
                  @finishUpload="finishUpload($event, index)"
                  @uploadErr="loading && loading.close()"
                >
                  <el-button
                    class="dialog-title--upload"
                    type="primary"
                    size="medium"
                    ref="uploadBtn"
                    >上传文件</el-button
                  >
                </bc-upload>

                <el-button
                  class="dialog-title--remove"
                  style="margin-left: 10px"
                  v-if="index >= minLength"
                  @click="removeOption(index)"
                  >删除</el-button
                >
              </div>
            </div>
           
            <template
              v-if="
                item.fileInfo.fileSuffix &&
                item.fileInfo.fileType &&
                item.fileInfo.fileUrl
              "
            >
              <bc-file-render
                style="margin-top: 16px"
                @remove="removeFile(index)"
                @againUpload="againUpload(index)"
                :fileInfo="item.fileInfo"
              ></bc-file-render>
            </template>
          </div>

          <div class="handler">
            <div
              class="handler-item"
              flex="cross:center"
              @click="up(index)"
              v-if="index !== 0"
            >
              <img :src="upIcon" />
              <span>上移</span>
            </div>
            <div
              class="handler-item"
              flex="cross:center"
              @click="down(index)"
              v-if="index < optionsList.length - 1"
            >
              <img :src="downIcon" />
              <span>下移</span>
            </div>
          </div>
        </div>

        <div style="width: 602px">
          <el-button
            @click="createOption"
            class="create-option"
            icon="el-icon-circle-plus"
            v-if="!isCloze"
          >
            添加选项
          </el-button>

          <div style="text-align: center" class="mt-3">
            <el-button class="dialog-close" @click="close">关闭</el-button>
            <el-button class="dialog-submit" type="primary" @click="submit"
              >完成</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import XEUtils from "xe-utils";

let sortString = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
import draggable from "vuedraggable";
import upIcon from "@/assets/images/up.png";
import downIcon from "@/assets/images/down.png";
import { getPlainText } from "@/utils";

export default {
  name: "bc-option",
  components: { draggable },

  props: {
    value: {
      type: String,
      default: "",
    },
    isCloze: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 2,
    },
    maxLength: {
      type: Number,
      default: 15,
    },
    minLength: {
      type: Number,
      default: 2,
    },
    defaultLength: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      isOpen: false,
      dialogTitle: "",
      optionsList: [],
      editIndex: null,
      editModel: "create",
      sortString: sortString.split(""),
      loading: null,
      isShowDialog: false,
      parentData: [],

      upIcon,
      downIcon,
      contentMaxLength: 10000,
    };
  },
  watch: {
    valueAndLimit: {
      handler(val) {
        if (val.value) {
          this.optionsList = JSON.parse(val.value);
          this.parentData = XEUtils.clone(this.optionsList, true);
        } else {
          let arr = [];
          for (let i = 0; i < val.defaultLength; i++) {
            arr.push({ title: "A", content: "", fileInfo: {} });
          }
          this.optionsList = this.isCloze ? [] : arr;
          this.parentData = XEUtils.clone(this.optionsList, true);
        }
      },
      immediate: true,
      deep: true,
    },
    haveMedia: {
      handler(val) {
        this.$emit("changeHaveMedia", val);
      },
      immediate: true,
    },
  },
  computed: {
    valueAndLimit() {
      return {
        value: this.value,
        minLength: this.minLength,
        defaultLength: this.defaultLength,
      };
    },
    haveMedia() {
      let isHave = false;
      isHave = this.optionsList.some(
        (i) =>
          !!(i.fileInfo.fileUrl && i.fileInfo.fileType && i.fileInfo.fileSuffix)
      );
      return isHave;
    },
  },
  mounted() {
    this.getConfigKey("rich-text-maxlength").then((response) => {
      // console.log(response)
      this.contentMaxLength = Number(response.msg);
    });
  },
  methods: {
    submit() {
      let flag = this.optionsList.some((i) => {
        let text = getPlainText(i.content);
        let reg = /<img [^>]*src=['"]([^'"]+)[^>]*>/g;
        let a = i.content.match(reg);

        return !text && !a && !i.fileInfo.fileUrl;
      });
      if (flag) {
        this.$message.error("请填写完整选项信息,内容和文件必须存在一个");
        return;
      }
      if (
        this.optionsList.some(
          (i) =>
            i.content &&
            getPlainText(i.content) &&
            getPlainText(i.content).length > this.contentMaxLength
        )
      ) {
        this.$message.error("内容最多输入" + this.contentMaxLength + "个字符");

        return;
      }
      this.isShowDialog = false;
      this.$emit(
        "input",
        JSON.stringify(
          this.optionsList.map((i, idx) => {
            let obj = { ...i, title: this.sortString[idx] };

            let objText = getPlainText(i.content);
            let objReg = /<img [^>]*src=['"]([^'"]+)[^>]*>/g;
            let objImage = i.content.match(objReg);

            obj.content = objText || objImage ? i.content : "";

            return obj;
          })
        )
      );
    },
    close() {
      this.isShowDialog = false;
      this.optionsList = XEUtils.clone(this.parentData, true);
    },
    up(index) {
      if (this.optionsList.length > 1 && index !== 0) {
        this.optionsList = this.swapItems(this.optionsList, index, index - 1);
      }
    },
    down(index) {
      if (
        this.optionsList.length > 1 &&
        index !== this.optionsList.length - 1
      ) {
        this.optionsList = this.swapItems(this.optionsList, index, index + 1);
      }
    },
    swapItems(arr, index1, index2) {
      arr[index1] = arr.splice(index2, 1, arr[index1])[0];
      return arr;
    },
    startUpload() {
      this.loading = this.$loading({
        lock: true,
        text: "上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    finishUpload(val, index) {
      let data = Object.assign(this.optionsList[index], { fileInfo: val });
      this.$set(this.optionsList, index, data);
      this.loading && this.loading.close();
    },
    removeFile(index) {
      let data = Object.assign(this.optionsList[index], {
        fileInfo: { fileUrl: "", fileType: "", fileSuffix: "" },
      });
      this.$set(this.optionsList, index, data);
    },
    againUpload(index) {
      this.$refs.uploadBtn[index].$el.click();
    },
    createOption() {
      // this.dialogTitle = '新增选项'
      // this.editModel = 'create'
      // this.$refs.editCommon.open()
      if (this.optionsList.length < this.maxLength) {
        this.optionsList.push({
          title: this.sortString[this.optionsList.length],
          content: "",
          fileInfo: {},
        });
      } else {
        this.$message.error(`最多添加${this.maxLength}个选项`);
      }
    },
    editOption(item, index) {
      // this.editIndex = index
      // this.editModel = 'edit'
      // this.dialogTitle = `编辑选项${this.sortString[index]}`
      // this.$refs.editCommon.open(item.content, {
      //   fileUrl: item.fileUrl,
      //   fileType: item.fileType,
      //   fileSuffix: item.fileSuffix
      // })
      this.isShowDialog = true;
    },
    changeContent({ content, file }) {
      if (this.editModel === "create") {
        this.optionsList.push({ content, ...file });
      } else {
        this.optionsList.splice(this.editIndex, 1, { content, ...file });
      }
      this.$emit(
        "input",
        JSON.stringify(
          this.optionsList.map((i, idx) => ({
            ...i,
            title: this.sortString[idx],
          }))
        )
      );
    },
    removeOption(index) {
      this.$confirm(`确认删除选项${this.sortString[index]}吗`, "提示")
        .then((res) => {
          if (res === "confirm") {
            this.optionsList.splice(index, 1);

            // this.$emit('input', JSON.stringify(this.optionsList.map((i, idx) => ({ ...i, title: this.sortString[idx] }))))
          }
        })
        .catch(() => {});
    },
    sortEnd() {
      this.optionsList = XEUtils.clone(this.parentData, true);
      this.$emit(
        "input",
        JSON.stringify(
          this.optionsList.map((i, idx) => ({
            ...i,
            title: this.sortString[idx],
          }))
        )
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.create-option {
  width: 100%;
  margin-top: 10px;
  border-style: dashed !important;
}

.option-item + .option-item {
  margin-top: 16px;
}

.ghostClass {
  .content {
    background: rgba(0, 0, 0, 0.3);
  }
}

.edit-item + .edit-item {
  margin-top: 10px;
}

.handler {
  width: 45px;
  margin-left: 20px;

  .handler-item {
    user-select: none;
    cursor: pointer;
  }

  .handler-item + .handler-item {
    margin-top: 10px;
  }
}
</style>
